import React, { JSXElementConstructor, ReactElement } from "react";
import { SubscriptionStatementDataResponse, SubscriptionStatementPageFactory } from "../../interfaces";
import { SubscriptionStatement, SubscriptionStatementFree } from "../screens/components";

export class SubscriptionStatementPageFactoryImpl implements SubscriptionStatementPageFactory {
    create(subscriptionData: SubscriptionStatementDataResponse | undefined): ReactElement<any, string | JSXElementConstructor<any>> {
        if (!subscriptionData?.success) return <SubscriptionStatementFree />;
        return <SubscriptionStatement statement={subscriptionData.response} />
    }
}